export const SIGNIN = "SIGNIN"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const LOGOUT = "LOGOUT"
export const UPDATE_ADMIN_PROFILE = "UPDATE_ADMIN_PROFILE"
export const GET_DETAIL_ADMIN_PROFILE = "GET_DETAIL_ADMIN_PROFILE"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const UPDATE_IMAGE_PROFILE = "UPDATE_IMAGE_PROFILE"
export const RESEND_OTP = "RESEND_OTP"

